import React, { FC, useMemo } from "react";
import { BurnNonSensitiveUi } from "../BurnNonSensitiveUi";
import { SizeClass } from "shared-ts-ui-responsive";
import {
  DataGridPremium,
  GridCallbackDetails,
  GridRowId,
  GridRowSelectionModel,
} from "@mui/x-data-grid-premium";
import { useBurnTableColumns } from "./useBurnTableColumns";
import { SxProps } from "@mui/material";
import { useMuiLocalization } from "shared-ts-mui";
import { SootingDegreeCalculationMethod } from "../../chimney/flue/SootingDegreeCalculationMethod";
import { OrganizationDto } from "../../organization/Organization";

const noRows: Array<BurnNonSensitiveUi> = [];
export interface BurnTableProps {
  organization: OrganizationDto;
  flueSootingDegreeCalculationMethod: SootingDegreeCalculationMethod;
  burns: Array<BurnNonSensitiveUi> | undefined;
  selected?: Array<boolean>;
  layout?: SizeClass;
  onSelected?: (burns: Array<boolean>) => void;
  sx?: SxProps;
}

export const BurnTable: FC<BurnTableProps> = (props) => {
  const burns = props.burns;
  const rows = burns ?? noRows;
  const gridSelectionModel: GridRowSelectionModel = useMemo(() => {
    const ids = new Set<GridRowId>();
    burns?.forEach((burn, index) => {
      if (props.selected?.[index] ?? false) {
        ids.add(burn.id);
      }
    });
    return {
      type: "include",
      ids: ids,
    };
  }, [burns, props.selected]);
  const multipleSelected = gridSelectionModel.ids.size > 1;
  const {
    columns,
    columnGroupingModel,
    columnVisibility,
    pinnedColumns,
    handleColumnWidthChange,
    handleColumnVisibilityChange,
  } = useBurnTableColumns(
    multipleSelected,
    props.flueSootingDegreeCalculationMethod,
    props.organization
  );
  const { muiLocalization } = useMuiLocalization();
  const handleRowSelectionModelChange = (
    rowSelectionModel: GridRowSelectionModel,
    details: GridCallbackDetails
  ) => {
    const selectedBurns: Array<boolean> = [];
    const selectedIds = rowSelectionModel.ids;
    burns?.forEach((burn) => {
      selectedBurns.push(selectedIds.has(burn.id));
    });

    return props.onSelected?.(selectedBurns);
  };

  return (
    <DataGridPremium
      localeText={
        muiLocalization.components.MuiDataGrid.defaultProps.localeText
      }
      columns={columns}
      columnGroupingModel={columnGroupingModel}
      columnVisibilityModel={columnVisibility}
      pinnedColumns={pinnedColumns}
      onColumnWidthChange={handleColumnWidthChange}
      onColumnVisibilityModelChange={handleColumnVisibilityChange}
      rows={rows}
      rowSelectionModel={gridSelectionModel}
      onRowSelectionModelChange={handleRowSelectionModelChange}
      sx={props.sx}
    />
  );
};
